// export function convertKeyValueToLabelValue(originalObject) {
//   const resultArray = [];
//   console.log(originalObject);
//   for (const key in originalObject) {
//     if (originalObject.hasOwnProperty(key)) {
//       const value = originalObject[key];
//       const keyValue = isNaN(key) ? key : Number(key);
//       resultArray.push({ value: keyValue, label: value });
//     }
//   }
//
//   return resultArray;
// }

export const moneyMultipler = 1000000;

export function convertKeyValueToLabelValue(originalObject) {
  const resultArray = [];

  for (const [key, value] of Object.entries(originalObject)) {
    resultArray.push({ value: key, label: value });
  }

  return resultArray;
}

export function generateUniqueId() {
  return 'id' + Date.now() + Math.random().toString(36).slice(2, 11);
}

export function environment() {
  return import.meta.env.VITE_APP_ENV || import.meta.env.MODE;
}
